var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [
        { name: "drag", rawName: "v-drag" },
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: {
        visible: _vm.dialogVisible,
        width: "1080px",
        "show-close": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.beforeClose,
        title: _vm.diaLogType ? "提单文件" : "上传附件",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "el-dialog__title",
          attrs: { slot: "title" },
          slot: "title",
        },
        [
          _vm._v(" " + _vm._s(_vm.diaLogType ? "提单文件" : "上传附件") + " "),
          _vm.rowData.isPushGGT
            ? _c("span", { staticClass: "ggt" }, [_vm._v("已推送GGT")])
            : _vm._e(),
        ]
      ),
      _c("div", { staticClass: "view" }, [
        _c(
          "div",
          { staticClass: "opt" },
          [
            _c("span", { staticClass: "label" }, [_vm._v("上传类型")]),
            _c("el-cascader", {
              staticStyle: { "margin-right": "15px", width: "200px" },
              attrs: {
                options: _vm.fileOptions,
                size: "mini",
                placeholder: "选择上传类型",
              },
              model: {
                value: _vm.type,
                callback: function ($$v) {
                  _vm.type = $$v
                },
                expression: "type",
              },
            }),
            _c("span", { staticClass: "label" }, [_vm._v("备注")]),
            _c("el-input", {
              staticStyle: { width: "500px" },
              attrs: {
                type: "textarea",
                rows: 1,
                placeholder: "请输入备注(非必填)",
              },
              model: {
                value: _vm.remark,
                callback: function ($$v) {
                  _vm.remark = $$v
                },
                expression: "remark",
              },
            }),
            _c(
              "el-upload",
              {
                attrs: {
                  action: "#",
                  "show-file-list": false,
                  "http-request": _vm.httpRequest,
                },
              },
              [
                _c("div", { staticClass: "upload" }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/bill/upload-1.png"),
                      alt: "",
                    },
                  }),
                  _vm._v(" 选择文件上传 "),
                ]),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "data" },
          _vm._l(_vm.tableData.columns, function (group) {
            return _c(
              "div",
              { key: group.uploadType, staticClass: "file-group" },
              [
                _c("div", { staticClass: "file-group-title" }, [
                  _vm._v(_vm._s(group.groupName)),
                ]),
                group.files?.length
                  ? _c(
                      "table",
                      { staticClass: "file-list" },
                      _vm._l(group.files, function (file) {
                        return _c(
                          "tr",
                          { key: file.id, staticClass: "file-item" },
                          [
                            _c("td", { staticClass: "file-name-box" }, [
                              _c("div", { staticClass: "file-item-icon" }, [
                                _c("img", { attrs: { src: file.icon } }),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass: "file-item-name",
                                  attrs: { title: file.fileName },
                                },
                                [_vm._v(_vm._s(file.fileName))]
                              ),
                              _c(
                                "div",
                                { staticClass: "common-label-success" },
                                [_vm._v(_vm._s(file.typeName))]
                              ),
                            ]),
                            _c("td", { staticClass: "file-item-time" }, [
                              _vm._v(
                                _vm._s(file.createdName) +
                                  " 于" +
                                  _vm._s(file.createdOn) +
                                  "上传"
                              ),
                            ]),
                            _c(
                              "td",
                              {
                                staticClass: "file-item-remark",
                                attrs: { title: file.remark },
                              },
                              [_vm._v(_vm._s(file.remark))]
                            ),
                            _c("td", { staticClass: "file-item-opt" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "flex-center",
                                  staticStyle: {
                                    gap: "10px",
                                    cursor: "pointer",
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/images/bill/download.png"),
                                      alt: "下载",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.download(file)
                                      },
                                    },
                                  }),
                                  _c("i", {
                                    staticClass: "el-icon-zoom-in",
                                    staticStyle: { color: "rgb(18, 88, 188)" },
                                    attrs: { alt: "查看" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.check(file)
                                      },
                                    },
                                  }),
                                  file.allowDel
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "btn",
                                          attrs: { title: "删除" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteFile(file)
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-delete",
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]),
                          ]
                        )
                      }),
                      0
                    )
                  : _c("div", { staticClass: "file-list flex-center" }, [
                      _vm._v("--"),
                    ]),
              ]
            )
          }),
          0
        ),
        _c("div", { staticClass: "footer" }, [
          _vm._v("*暂时只支持图片和PDF查看"),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }